import React from "react";

import { css } from "@emotion/core";

import {
  Alert,
  AlertDescription,
  Button,
  ButtonGroup,
} from "@zapier/design-system";

const planNotFoundCss = css`
  margin: 2rem auto;
  padding: 2rem;
  text-align: center;
  max-width: 800px;
`;

/*
    If the plan we're upgrading/downgrading/changing is invalid, don't render the checkout.
  */
export const PlanNotFound = ({ toPlanName }: { toPlanName?: string }) => {
  // Log invalid plan name
  console.log(
    JSON.stringify({
      message: "Checkout app: invalid URL/plan name",
      planName: toPlanName,
      url: window.location.href,
    })
  );
  return (
    <div css={planNotFoundCss}>
      <Alert type="error">
        <AlertDescription>
          <p>
            <strong>Oops!</strong> We couldn&lsquo;t find the plan you have
            requested. Please verify you have the correct URL or contact
            support.
          </p>
          <ButtonGroup columnSize="minmax(150px, 200px)" justify="center">
            <Button color="primary" href="/app/pricing" size="small">
              Go to pricing page
            </Button>
            <Button color="secondary" href="/help" size="small">
              Get help
            </Button>
          </ButtonGroup>
        </AlertDescription>
      </Alert>
    </div>
  );
};
